import { VFC } from 'hoist-non-react-statics/node_modules/@types/react'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

const DeleteMemo: VFC<ModalProps<{ deleteMemo: () => Promise<any> }>> = ({
  deleteMemo,
  close,
}) => (
  <Layout>
    <h3>メモを削除しますか？</h3>
    <p>一度削除されたメモは復元できません。</p>
    <ButtonsDiv>
      <CancelButton onClick={close}>キャンセル</CancelButton>
      <Button
        onClick={async () => {
          await deleteMemo()
          close()
        }}
      >
        削除
      </Button>
    </ButtonsDiv>
  </Layout>
)

export const DeleteMemoModal = asModal(DeleteMemo)
